// http://lokeshdhakar.com/projects/lightbox2/

lightbox.option({
    albumLabel: 'Image %1 sur %2'
});
